export const getExerciseName = (exercise: string) => {
    switch (exercise) {
    case 'jumping jacks':
        return '開合跳'
    case 'glute bridge':
        return '臀橋'
    case 'high knees':
        return '高抬腿'
    case 'left right jump':
        return '左右跳'
    case 'lying leg raise':
        return '仰臥抬腿'
    case 'push up':
        return '俯臥撑'
    case 'run':
        return '百米飛人'
    case 'sit up':
        return '仰臥起坐'
    case 'squat':
        return '深蹲'
    case 'swim':
        return '游泳健將'
    default:
        return exercise
    }
}

export const getModeName = (mode: string) => {
    switch(mode) {
    case 'random':
        return '隨機練習'
    case 'practice':
        return '單人練習'
    case 'competition':
        return '多人競賽'
    default:
        return mode
    }
}